// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".PlanningModalSeparation_separation__2DS7R {\n  height: 1px;\n  margin: 2px 0px 8px;\n  background: #1fb9c7;\n}\n", "",{"version":3,"sources":["webpack://src/Components/Planning/PlanningModalSeparation.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,mBAAmB;AACrB","sourcesContent":[".separation {\n  height: 1px;\n  margin: 2px 0px 8px;\n  background: #1fb9c7;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"separation": "PlanningModalSeparation_separation__2DS7R"
};
export default ___CSS_LOADER_EXPORT___;
